var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserWithDisabledCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5128 11.5C15.4458 11.5 17.0128 9.933 17.0128 8C17.0128 6.067 15.4458 4.5 13.5128 4.5C11.5798 4.5 10.0128 6.067 10.0128 8C10.0128 9.933 11.5798 11.5 13.5128 11.5Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27218 14.1747C10.397 13.104 11.9221 12.5017 13.5128 12.5C15.1036 12.5017 16.6286 13.104 17.7535 14.1747C18.8783 15.2454 19.511 16.6971 19.5128 18.2114C19.5128 18.2114 18.2271 21.5 13.5128 21.5C8.79853 21.5 7.51282 18.2114 7.51282 18.2114C7.51463 16.6971 8.14736 15.2454 9.27218 14.1747Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWithDisabledCamera);
export default __webpack_public_path__ + "static/media/user-with-disabled-camera.ddbad5b700d145f1d297b673112acfc0.svg";
export { ForwardRef as ReactComponent };